<template>
  <div class="fccRelatoriosPermissao">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            :optionsButton="optionsButton"
            :items="listagemRelatorioPermissao"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Nova Permissão Relatório"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarRelatorioPermissao" autocomplete="off">
        <div class="my-2">
          <div class="row">
            <div class="col-sm-6">
              <label>Selecione o tipo</label>
              <b-form-select name="Tipo" label="Tipo" class="selectSPI" v-model="tipoGrupo">
                <option value="1">Perfil</option>
                <option value="2">Usuário</option>
              </b-form-select>
            </div>
            <div class="col-sm-12 my-2" v-if="tipoGrupo == 1">
              <v-select
                :options="grupoListando"
                v-model="grupoSelecionado"
                class="selectSPI"
                label="pernome"
                placeholder="Selecione um perfil"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!grupoSelecionado"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
            <div class="col-sm-12 my-2" v-if="tipoGrupo == 2">
              <v-select
                :options="usuarioListando"
                v-model="grupoSelecionado"
                class="selectSPI"
                label="usuid"
                placeholder="Selecione um usuário"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!grupoSelecionado"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Permissões Relatórios',
      titlePDF: 'Lista de Permissões Relatórios',
      itemPorPage: '100',
      listagemRelatorioPermissao: [],
      repositorioSelected: '',
      grupoSelecionado: [],
      excluirRelatorioPermissao: 'Relatorio/ExcluirPermissaoObj',
      inserirRelatorioPermissao: 'Relatorio/AdicionarPermissaoObj',
      listandoTodosRelatoriosPermissao: 'Relatorio/ListarPermissaoObj',
      groupId: '',
      tipoGrupo: '',
      criar: {
        objid: '',
        perid: null,
        usuid: null
      },
      actions: [
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'addField',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        { funcaoButton: 'voltaMenu', tooltip: 'Voltar', icon: 'chevron-left' }
      ],
      fields: [
        { key: 'objusuid', label: 'Código', sortable: true, active: true },
        { key: 'usuid', label: 'Usuário', sortable: true, active: true },
        { key: 'pernome', label: 'Grupo', sortable: true, active: true },
        { key: 'objnome', label: 'Perfil', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ]
    }
  },
  methods: {
    listandoRelatoriosPermissao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlRelatorios + this.listandoTodosRelatoriosPermissao + '?id=' + this.groupId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemRelatorioPermissao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    voltaMenu: function () {
      this.$router.push({ path: '/relatorios/cadastro' })
    },
    addField: function () {
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlRelatorios + this.excluirRelatorioPermissao + '/' + item.objusuid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoRelatoriosPermissao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    criarRelatorioPermissao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.criar.objid = this.groupId
      if (this.tipoGrupo === '1') {
        delete this.criar.usuid
        this.criar.perid = this.grupoSelecionado.perid
      } else {
        delete this.criar.perid
        this.criar.usuid = this.grupoSelecionado.usuid
      }
      axios
        .post(
          this.baseUrlRelatorios + this.inserirRelatorioPermissao,
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoRelatoriosPermissao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlRelatorios = store.state.baseUrlRelatorios
    this.groupId = this.$route.params.id
    this.listandoRelatoriosPermissao()
    this.gruposListando()
    this.usuariosListando()
  },
  created: function () {
    this.groupId = this.$route.params.id
  }
}
</script>
